import ProjectEditorDetail from "../editor/Detail";
import Global from "components/common/Global";
import CryptoJS from 'crypto-js';

/** 编辑器库需要用到 */
window.CryptoJS = CryptoJS ;

export default function ProjectEditor(){
    return (
        <Global>
            <ProjectEditorDetail isMockupsSrc={true}/>
        </Global>
    )
}